<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant
            type="search"
            name="plantCd"
            v-model="searchParam.plantCd"
            @input="getList"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="유해화학자재 목록"
      tableId="grid"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      :selection="popupParam.type"
      :usePaging="false"
      rowKey="mdmChemMaterialId"
      @linkClick="linkClick"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <!-- <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" /> -->
          <c-btn
            v-if="editable"
            label="LBLSELECT"
            icon="check"
            @btnClicked="select"
          />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "hsl-manage-pop",
  props: {
    popupParam: {
      type: Object,
      default: function () {
        return {
          type: "multiple",
          plantCd: "",
        };
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        regulatedItemCd: ["D10010001"],
        searchItems: ["D100"],
        useFlag: "Y",
      },
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "사업장명",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
          {
            name: "materialCd",
            field: "materialCd",
            label: "자재코드",
            align: "center",
            style: "width:90px",
            sortable: true,
          },
          {
            name: "materialName",
            field: "materialName",
            label: "화학자재명",
            align: "left",
            type: "link",
            style: "width:160px",
            sortable: true,
          },
          {
            name: "propertiesStateName",
            field: "propertiesStateName",
            label: "성상",
            align: "center",
            style: "width:60px",
            sortable: true,
          },
          {
            name: "mixFlagName",
            field: "mixFlagName",
            label: "구성",
            align: "center",
            style: "width:60px",
            sortable: true,
          },
          {
            name: "inputDissolutionTank",
            field: "inputDissolutionTank",
            label: "사용제품명",
            align: "center",
            isEllipsis: true,
            maxWidth: "120px",
            style: "width:120px",
            sortable: true,
          },
          {
            name: "usageName",
            field: "usageName",
            label: "용도",
            align: "left",
            style: "width:110px",
            sortable: true,
          },
        ],
        data: [],
        height: "",
      },
      editable: true,
      listUrl: "",
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  watch: {
    contentHeight() {
      let height =
        this.contentHeight - this.$refs["searchbox"].$el.offsetHeight - 100;
      if (height < 200) {
        height = 350;
      }
      this.grid.height = height + "px";
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.mdm.mam.chem.listreg.url;
      if (this.popupParam.plantCd) {
        this.searchParam.plantCd = this.popupParam.plantCd;
      }
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    linkClick(row) {
      this.popupOptions.title = "화학자재 상세";
      this.popupOptions.param = {
        mdmChemMaterialId: row ? row.mdmChemMaterialId : "",
        plantCd: row ? row.plantCd : "",
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/mdm/mam/chemDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    select() {
      let selectData = this.$refs["table"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSGNOITEMS", // 선택된 항목이 없습니다.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === "single") {
        this.$emit("closePopup", [row]);
      }
    },
  },
};
</script>
